// extracted by css-extract-rspack-plugin
export default {"IndustryCombobox":"sputnik__IndustryCombobox__m2NZY","industryCombobox":"sputnik__IndustryCombobox__m2NZY"};